import React from "react";
import "twin.macro";
import { graphql } from "gatsby";
import { PageLayout, CTA } from "../components";

const Lenses = ({ data: { strapiDsrLenses } }) => {
  return (
    <PageLayout {...strapiDsrLenses} flourish={1}>
      <CTA />
    </PageLayout>
  );
};

export default Lenses;

export const query = graphql`
  query lensesPageQuery {
    strapiDsrLenses {
      content
      subtitle
      intro
      title
    }
  }
`;
